import React, {useState} from 'react';
import {useTranslate} from '@computerrock/formation-i18n';
import './PrintData.scss';
import PrintModal from '../../application/modals/PrintModal';

const PrintData = ({selectedColumn, isPrintUrl, printTitle, isShown}) => {
    const [isOpen, setIsOpen] = useState(isPrintUrl ?? false);
    const [showTooltip, setShowTooltip] = useState(false);
    const {createTranslateShorthand} = useTranslate();
    const translateScreen = createTranslateShorthand('categories_screen');

    const handlePrint = () => {
        try {
            if (!document.execCommand('print', false, null)) {
                window.print();
            }
        } catch {
            window.print();
        }
    };

    const handleOpenModal = () => {
        setIsOpen(!isOpen);
    };

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div className={`sski-c-top-navigation-bar__print_container ${isOpen ? 'is-absolute' : ''}`}>
            <div
                className="sski-c-top-navigation-bar__print_button-container"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <button
                    onClick={handleOpenModal}
                    disabled={!isShown}
                    className={`sski-c-top-navigation-bar__print_button  button is-white is-rounded is-responsive is-size-6 has-text-weight-medium  ${isShown ? '' : 'is-disabled no-border has-text-grey'}`}
                >
                    {selectedColumn} {translateScreen('button_label.print')}
                </button>
                {(!isShown && showTooltip) && (
                <div className="sski-c-tooltip is-absolute is-flex rounded is-align-items-center">
                    <div className="tooltip-body has-text-centered px-3 py-2">
                        {translateScreen('tooltip_label.print')}
                    </div>
                </div>
                )}
            </div>

            {isOpen && (
            <PrintModal
                closeModal={handleOpenModal}
                printColumn={handlePrint}
                selectedColumn={selectedColumn}
                printTitle={printTitle}
            />
            )}
        </div>
    );
};

export default PrintData;
